// extracted by mini-css-extract-plugin
module.exports = {"rule":"SetPasswordRule_rule__10-yh","icon":"SetPasswordRule_icon__2fZBC","icon--checked":"SetPasswordRule_icon--checked__1hHhi"};